module.exports = __webpack_public_path__ + "static/img/img_t.97b87eb9.webp";